"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RUN_OUT_TOLERANCE = 5;
var PreservationTable_1 = require("./PreservationTable");
var Gender_1 = require("../lib/Gender");
var PersonOutput = (function () {
    function PersonOutput(params, isSubject) {
        this.year = [];
        this.age = [];
        this.salary = [];
        this.midYearSalary = [];
        this.workload = [];
        this.dbMultiple = [];
        this.preTaxContributions = [];
        this.postTaxContributions = [];
        this.lumpsumContributions = [];
        this.employerContributions = [];
        this.coContributions = [];
        this.ttrContributions = [];
        this.ttrDrawings = [];
        this.otherIncome = [];
        this.targetIncome = [];
        this.minimumDrawings = [];
        this.insuranceFees = [];
        this.administrationFees = [];
        this.drawings = [];
        this.dbAssetsStartOfYear = [];
        this.drbAssetsStartOfYear = [];
        this.agePension = [];
        this.indexedPension = [];
        this.accumulationAssetsStartYear = [];
        this.pensionAssetsStartYear = [];
        this.accumulationAssetsEndYear = [];
        this.pensionAssetsEndYear = [];
        this.drawingsFromPensionAccount = [];
        this.drawingsFromAccumulationAccount = [];
        this.deflatedSalary = [];
        this.deflatedPreTaxContributions = [];
        this.deflatedPostTaxContributions = [];
        this.deflatedNetSalary = [];
        this.deflatedOtherIncome = [];
        this.deflatedTargetIncome = [];
        this.deflatedAgePension = [];
        this.deflatedIndexedPension = [];
        this.deflatedDrawingsInYear = [];
        this.deflatedAccumulationDrawingsInYear = [];
        this.deflatedPensionDrawingsInYear = [];
        this.deflatedActualDrawingsInYear = [];
        this.deflatedAssetsInYear = [];
        this.deflatedAccumulationAssetsInYear = [];
        this.deflatedPensionAssetsInYear = [];
        this.deflatedMinimumDrawingsInYear = [];
        this.deflatedInsuranceFees = [];
        this.deflatedEmployerContributions = [];
        var calculationDate = params.getParamObject("CalculationDate");
        var sex = params.getParamString(isSubject ? "Sex" : "Sex_2");
        var ageNow = params.getParamNumber(isSubject ? "AgeNow" : "AgeNow_2");
        this.preservationAge = this.calculatePreservationAge(this.calculateDateOfBirth(calculationDate, ageNow));
        this.lifeExpectancy = this.calculateLifeExpectancy(params.getParamObject("AbsLifeTable"), ageNow, sex);
    }
    PersonOutput.prototype.populateYear = function (yearCount, person, account, employer) {
        this.year.push(yearCount);
        this.age.push(person.age);
        this.salary.push(person.getSalaryInYear(yearCount));
        this.midYearSalary.push(person.getMidYearSalaryInYear(yearCount));
        this.workload.push(person.getWorkLoadInYear(yearCount));
        this.dbMultiple.push(account.getAccruedDBMultipleInYear(yearCount));
        this.preTaxContributions.push(person.preTaxMemberContributions);
        this.postTaxContributions.push(person.postTaxMemberContributions);
        this.lumpsumContributions.push(person.lumpSumContribution);
        this.employerContributions.push(employer.getEmployerContributionsInYear(yearCount));
        this.coContributions.push(person.coContributions);
        this.ttrContributions.push(person.getTTRContributionsInYear(yearCount));
        this.ttrDrawings.push(person.getTTRDrawingsInYear(yearCount));
        this.otherIncome.push(person.getOtherIncomeInYear(yearCount));
        this.targetIncome.push(person.getTargetIncomeInYear(yearCount));
        this.agePension.push(person.getAgePensionInYear(yearCount));
        this.indexedPension.push(person.getIndexedPensionInYear(yearCount));
        this.minimumDrawings.push(account.getMinimumDrawings(yearCount));
        this.insuranceFees.push(account.getInsuranceFeesInYear(yearCount));
        this.administrationFees.push(account.getAdministrationFeesInYear(yearCount));
        this.drawings.push(account.getDrawingsInYear(yearCount));
        this.dbAssetsStartOfYear.push(account.getDBAssetsInYear(yearCount));
        this.drbAssetsStartOfYear.push(account.getDeferredRetirementAssetsInYear(yearCount));
        this.accumulationAssetsStartYear.push(account.getAccumulationAssetsInYear(yearCount));
        this.pensionAssetsStartYear.push(account.getPensionAssetsInYear(yearCount));
        this.accumulationAssetsEndYear.push(account.getAccumulationAssetsInYear(yearCount + 1));
        this.pensionAssetsEndYear.push(account.getPensionAssetsInYear(yearCount + 1));
        this.drawingsFromPensionAccount.push(account.getDrawingsFromPensionAccountInYear(yearCount));
        this.drawingsFromAccumulationAccount.push(account.getDrawingsFromAccumulationAccountInYear(yearCount));
    };
    PersonOutput.prototype.addDeflatedData = function (totalYears, person, account, employer) {
        for (var yearCount = 1; yearCount <= totalYears; yearCount++) {
            this.deflatedSalary.push(person.getDeflatedSalaryInYear(yearCount));
            this.deflatedPreTaxContributions.push(person.getDeflatedPreTaxContributionsInYear(yearCount));
            this.deflatedPostTaxContributions.push(person.getDeflatedPostTaxContributionsInYear(yearCount));
            this.deflatedNetSalary.push(person.getDeflatedNetSalaryInYear(yearCount));
            this.deflatedOtherIncome.push(person.getDeflatedOtherIncomeInYear(yearCount));
            this.deflatedTargetIncome.push(person.getDeflatedTargetIncomeInYear(yearCount));
            this.deflatedAgePension.push(person.getDeflatedAgePensionInYear(yearCount));
            this.deflatedIndexedPension.push(person.getDeflatedIndexedPensionInYear(yearCount));
            this.deflatedDrawingsInYear.push(account.getDeflatedDrawingsInYear(yearCount));
            this.deflatedAccumulationDrawingsInYear.push(account.getDeflatedAccumulationAccountDrawingsInYear(yearCount));
            this.deflatedPensionDrawingsInYear.push(account.getDeflatedPensionAccountDrawingsInYear(yearCount));
            this.deflatedActualDrawingsInYear.push(account.getDeflatedActualDrawingsInYear(yearCount));
            this.deflatedMinimumDrawingsInYear.push(account.getDeflatedMinimumDrawingsInYear(yearCount));
            this.deflatedInsuranceFees.push(account.getDeflatedInsuranceFeesInYear(yearCount));
            this.deflatedAssetsInYear.push(account.getDeflatedAssetsInYear(yearCount));
            this.deflatedAccumulationAssetsInYear.push(account.getDeflatedAccumulationAssetsInYear(yearCount));
            this.deflatedPensionAssetsInYear.push(account.getDeflatedPensionAssetsInYear(yearCount));
            this.deflatedEmployerContributions.push(employer.getDeflatedEmployerContributionsInYear(yearCount));
        }
    };
    PersonOutput.prototype.removeWithdrawalFromActualDrawings = function (index, withdrawal) {
        this.deflatedActualDrawingsInYear[index] = Math.max(0, this.deflatedActualDrawingsInYear[index] - withdrawal);
    };
    Object.defineProperty(PersonOutput.prototype, "runOutAge", {
        get: function () {
            var i = this.age.length - 1;
            while (this.deflatedAssetsInYear[i] < RUN_OUT_TOLERANCE && i > 0) {
                i--;
            }
            return this.age[i] + 1;
        },
        enumerable: true,
        configurable: true
    });
    PersonOutput.prototype.calculatePreservationAge = function (dateOfBirth) {
        return PreservationTable_1.PreservationTable.createDefault().preservationAge(dateOfBirth);
    };
    PersonOutput.prototype.calculateDateOfBirth = function (calculationDate, ageNow) {
        return calculationDate.plus(-0.5 - ageNow);
    };
    PersonOutput.prototype.calculateLifeExpectancy = function (lifeTable, ageNow, sex) {
        var gender = Gender_1.Gender.fromString(sex);
        var age = Math.max(ageNow, lifeTable.startAge);
        var yearsLeft = Math.floor(lifeTable.lifeExpectancy(age, gender));
        return age + yearsLeft;
    };
    return PersonOutput;
}());
exports.PersonOutput = PersonOutput;
//# sourceMappingURL=PersonOutput.js.map